var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c("el-tab-pane", {
            attrs: { label: "上传excel", name: "batchorderfencang" }
          }),
          _vm._v(" "),
          _c("el-tab-pane", {
            attrs: { label: "已上传列表", name: "waitshiplist" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "300px",
              "margin-left": "10%",
              "margin-top": "20px",
              "margin-bottom": "40px"
            }
          },
          [
            _c("p", { staticStyle: { "font-size": "30px" } }, [
              _vm._v(_vm._s(_vm.resData.origin) + "发货")
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              { attrs: { model: _vm.form } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "快递公司" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择快递公司" },
                        model: {
                          value: _vm.form.shipping_name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "shipping_name", $$v)
                          },
                          expression: "form.shipping_name"
                        }
                      },
                      _vm._l(_vm.resData.shipping_company, function(shipping) {
                        return _c("el-option", {
                          key: shipping.shipping_name,
                          attrs: {
                            label: shipping.shipping_company,
                            value: shipping.shipping_name
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "导入快递单" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "upload-demo",
                        attrs: {
                          action: _vm.action,
                          name: "excel",
                          accept: ".xls,.xlsx,.csv",
                          "on-preview": _vm.handlePreview,
                          "on-remove": _vm.handleRemove,
                          "before-remove": _vm.beforeRemove,
                          limit: 1,
                          "on-exceed": _vm.handleExceed,
                          "on-success": _vm.uploadSuccess,
                          "before-upload": _vm.beforeUpload,
                          "file-list": _vm.fileList,
                          "with-credentials": ""
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "small", type: "primary" } },
                          [_vm._v("点击上传")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                  [_vm._v("批量发货")]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e4f9406", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4f9406","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/batchOrderFencang.vue
// module id = null
// module chunks = 